// extracted by mini-css-extract-plugin
module.exports = {"bttnStyle":"numericDisplay_bttnStyle__3U6Yx","bttnStyleDisabled":"numericDisplay_bttnStyleDisabled__345Wk","bttnStyle2":"numericDisplay_bttnStyle2__p0VCB"};